<pre class="card card-block card-header">{{radioModel || 'null'}}</pre>
<div class="form-inline">
  <div class="btn-group me-2" btnRadioGroup [(ngModel)]="radioModel" [disabled]="modelGroupDisabled">
    <label class="btn btn-success" btnRadio="Left">Left</label>
    <label class="btn btn-success" btnRadio="Middle">Middle</label>
    <label class="btn btn-success" btnRadio="Another" [disabled]="true">Disabled</label>
    <label class="btn btn-success" btnRadio="Right">Right</label>
  </div>
  <button class="btn btn-warning" (click)="modelGroupDisabled = !modelGroupDisabled">Enable/Disable</button>
</div>


<pre class="card card-block card-header">{{radioModelDisabled || 'null'}}</pre>
<div class="form-inline">
  <div class="btn-group" btnRadioGroup [(ngModel)]="radioModelDisabled" disabled>
    <label class="btn btn-success" btnRadio="Left">Left</label>
    <label class="btn btn-success" btnRadio="Middle">Middle</label>
    <label class="btn btn-success" btnRadio="Right">Right</label>
  </div>
</div>
